import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import LanguageDetector from 'i18next-browser-languagedetector'
import HttpBackend from 'i18next-http-backend'

i18n
  .use(HttpBackend)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    fallbackLng: 'he',
    supportedLngs: ['he', 'en', 'ar'],
    debug: import.meta.env.DEV,

    // Hebrew is the default. We intentionally do NOT detect from the
    // browser language ('navigator') or the <html> tag — otherwise an
    // English/Arabic browser would auto-switch away from Hebrew. Only an
    // explicit choice counts: a ?lng= query param or a previously saved
    // selection in localStorage. Everything else falls back to 'he'.
    detection: {
      order: ['querystring', 'localStorage'],
      lookupQuerystring: 'lng',
      caches: ['localStorage'],
    },

    backend: {
      loadPath: '/locales/{{lng}}/{{ns}}.json',
    },

    ns: ['common', 'home', 'products', 'about'],
    defaultNS: 'common',

    interpolation: {
      escapeValue: false,
    },

    react: {
      useSuspense: true,
    },
  })

export default i18n
